import { SxProps, Theme } from "@mui/material";

const getStyles = (theme: Theme): Record<string, Record<string, SxProps<Theme>>> => ({
  RoadWay: {
    container: {
      flexDirection: "column",
      // gap: "var(--rhythm)",
      p: "calc(2 * var(--rhythm))",
      [theme.breakpoints.down("md")]: {
        p: "var(--rhythm)",
      },
    },

    image: {
      mb: "calc(2 * var(--rhythm))",
    },

    roadway: {
      [theme.breakpoints.down("md")]: {
        ".RlxSection-content": {
          marginX: "calc(-1 * var(--rhythm))",
          borderRadius: 0,
        },
      },
    },

    grid: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "calc(2 * var(--rhythm)) calc(2 * var(--rhythm))",
      mb: "calc(2 * var(--rhythm))",
      [theme.breakpoints.down("md")]: {
        gridTemplateColumns: "1fr",
        gap: "var(--rhythm)",
        mb: "var(--rhythm)",
      },
    },

    borders: {
      flexDirection: "row",
      gap: "calc(2 * var(--rhythm))",
      mt: "calc(2 * var(--rhythm))",
      [theme.breakpoints.down("md")]: {
        flexWrap: "wrap",
        gap: "var(--rhythm)",
        mt: "var(--rhythm)",
      },
    },
  },

  BorderArea: {
    area: {
      width: "50%",
      ".RlxSection-content": {
        display: "flex",
        flexDirection: "column",
        gap: "calc(2 * var(--rhythm))",
      },
      [theme.breakpoints.down("md")]: {
        width: "100%",
        ".RlxSection-content": {
          gap: "var(--rhythm)",
          marginX: "calc(-1 * var(--rhythm))",
          borderRadius: 0,
        },
      },
    },
  },
});

export default getStyles;
